const consoleTap = <T extends unknown[]>(...all: T) => {
    return all;
};

export { consoleTap };
